import axios from '../../axios';
import * as types from '../actionTypes';

const fetchForumsRequest = () => ({type: types.FETCH_FORUMS_REQUEST});
const fetchForumsSuccess = forums => ({type: types.FETCH_FORUMS_SUCCESS, forums});
const fetchForumsFailure = error => ({type: types.FETCH_FORUMS_FAILURE, error});

export const fetchForums = query => {
  return dispatch => {
    dispatch(fetchForumsRequest());
    return axios.get(`/api/list/forums${query || ''}`).then(
      response => {
        dispatch(fetchForumsSuccess(response.data));
      },
      error => {
        dispatch(fetchForumsFailure(error));
      }
    )
  }
};

const createForumRequest = () => ({type: types.CREATE_FORUM_REQUEST});
const createForumSuccess = (forum, status) => ({type: types.CREATE_FORUM_SUCCESS, forum, status});
const createForumFailure = error => ({type: types.CREATE_FORUM_FAILURE, error});

export const createForum = data => {
  return dispatch => {
    dispatch(createForumRequest());
    return axios.post('/api/private/forum', data).then(
      response => {
        dispatch(createForumSuccess(response.data, response.status));
      },
      error => {
        dispatch(createForumFailure(error));
      }
    )
  }
};